import React from "react";

interface MarkerProps {
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const Marker: React.FC<MarkerProps> = ({ style, children }) => (
  <div style={style}>{children}</div>
);

export default Marker;
